<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3><span>RIMBORSO N° {{n_rimborso}} </span></h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <form-wizard v-if="selected" ref="wiz" autofocus color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" nextButtonText="Avanti" backButtonText="Indietro" finishButtonText="Chiudi" @on-complete="closeSidebar">
          <!-- tab 1 content -->
          <tab-content title="Rimborso" class="mb-5" icon="feather icon-pocket">
            <form data-vv-scope="step-1">
              <vs-row justify="center">
                <vs-col>
                  <h5>Creato il {{[': ',$tariffe.formatDateNew(selected.data_inserimento)].join(' ')}}</h5>
                </vs-col>
                <vs-col class="md:w-6/12 w-full" w="2">
                  <template v-if="selected['azienda']">
                    <vs-col class="mt-4">
                      <label class="text-sm bold">Azienda:</label>
                      <p>
                        {{selected.azienda.ragione_sociale}}
                      </p>
                    </vs-col>
                    <vs-col class="mt-4" v-if="selected.azienda.contatti && selected.azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93)">
                      <label class="sm">Titolare/Legale Rappresentante</label>
                      <p>
                        {{[selected.azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93).contatto.cognome,selected.azienda.contatti.find( c => c.id_ruolo == 1 || c.id_ruolo == 93).contatto.nome].join(" ")}}
                      </p>
                    </vs-col>
                  </template>
                  <!-- <template v-if="selected['contatto']"> -->
                  <template v-else>
                    <vs-col class="mt-4">
                      <label class="text-sm bold">Contatto:</label>
                      <p>
                        {{[selected.contatto.nome,selected.contatto.cognome].join(' ')}}
                      </p>
                    </vs-col>
                  </template>
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Codice Ufficio:</label>
                    <p>
                      {{`${selected.ufficio['descrizione']} ( ${selected.ufficio['codice']} )`}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Servizio:</label>
                    <p>
                      {{selected.servizio.codice}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Nome Cognome (Consulente/Operatore del servizio):</label>
                    <p>
                      {{selected.operatore_nome}}
                    </p>
                  </vs-col>
                </vs-col>
                <vs-col class="md:w-6/12 w-full">
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Destinato a</label>
                    <p>
                      {{selected.destinatario}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Anno insorgenza errore:</label>
                    <p>
                      {{selected.anno_insorgenza_errore}}
                    </p>
                  </vs-col>
                  <vs-col v-if="selected.stato !='paid'" class="mt-2">
                    <label class="text-sm bold">Importo:</label>
                    <p>
                      {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo),' €'].join(' ')}}
                    </p>
                  </vs-col>
                  <vs-col v-else class="mt-2">
                    <label class="text-sm bold">Importo (di cui pagato):</label>
                    <p>
                      {{[
                        new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo),
                        `(${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo_pagato)})`,
                        ' €'
                      ].join(' ')}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2" :vs-w="selected.importo >= 1500 ? 6 : 12">
                    <label class="text-sm bold">Sinistro con seguito:</label>
                    <p>
                      {{selected.seguito_sinistro ? 'Si' : 'No'}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2" vs-w="6" v-if="selected.importo >= 1500">
                    <label class="text-sm bold">Apertura sinistro Assicurazione:</label>
                    <p>
                      {{selected.apertura_sinistro ? 'Si' : 'No'}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="text-sm bold">Iban:</label>
                    <p>
                      {{selected.iban}}
                    </p>
                  </vs-col>
                </vs-col>
              </vs-row>
            </form>
          </tab-content>
          <!-- tab 2 content -->
          <tab-content title="Descrizione" class="mb-5" icon="feather icon-type">
            <form data-vv-scope="step-2" v-on:submit.prevent="stop">
              <vs-row>
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="TypeIcon" class="mr-2 c-primary" />
                  <span class="font-medium text-lg leading-none">Descrizione del fatto e motivazione della richiesta</span>
                </div>
                <vs-divider />
              </vs-row>
              <vs-row class="m-top-5">
               <vs-col class="lg:w-5/5 w-full">
                 <div id="quill-note" class="quill vx-col w-5/6" />
                 <!-- <p>
                   {{selected.note_plain}}
                 </p> -->
               </vs-col>
              </vs-row>
            </form>
          </tab-content>
          <!-- tab 3 content -->
          <tab-content title="Allegati" class="mb-5" icon="feather icon-list">
            <StepDocumentazione :form="selected.documentazione" :is_readonly="true" />
          </tab-content>
          <!-- tab 3_bis content -->
          <tab-content v-if="selected.assicurazione" title="Assicurazione" class="mb-5" icon="feather icon-corner-down-left">
            <form data-vv-scope="step-3-bis">
              <vs-row justify="center">
                <vs-col class="md:w-6/12 w-full" w="2">
                  <vs-col class="mt-4">
                    <label class="text-sm bold">Compagnia assicurativa:</label>
                    <p>
                      {{selected.compagnia_assicurazione}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-4">
                    <label class="sm">Numero pratica assicurazione:</label>
                    <p>
                      {{selected.numero_polizza_assicurazione}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-4">
                    <label class="sm">Data apertura pratica:</label>
                    <p>
                      {{$tariffe.formatDateNew(selected.data_apertura_assicurazione)}}
                    </p>
                  </vs-col>
                </vs-col>
                <vs-col class="md:w-6/12 w-full" w="2">
                  <vs-col class="mt-4">
                    <label class="text-sm bold">Importo:</label>
                    <p>
                      {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo),' €'].join(' ')}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-4">
                    <label class="sm">Importo rimborsato:</label>
                    <p>
                      {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo_rimborsato_assicurazione),' €'].join(' ')}}
                    </p>
                  </vs-col>
                  <vs-col class="mt-4">
                    <label class="sm">Data liquidazione pratica:</label>
                    <p>
                      {{$tariffe.formatDateNew(selected.data_liquidazione_assicurazione)}}
                    </p>
                  </vs-col>
                </vs-col>
              </vs-row>
            </form>
          </tab-content>
          <!-- tab 4 content -->
          <tab-content title="Storia" class="mb-5" icon="feather icon-feather">
            <vs-row vs-justify="space-around">
              <vs-col vs-w="6">
                <vs-row class="bold sidebar-header-row mt-4 p-3" vs-justify="flex-start">
                  <h3>Storia degli stati:</h3>
                </vs-row>
                <vs-row class="sidebar-header-row mt-4 text-center" vs-justify="flex-start">
                  <vs-col vs-w="10">
                    <ul class="activity-timeline">
                      <li v-for="(el,idx) in selected.stati" v-bind:key="idx" style="margin-bottom:3rem;" >
                        <div
                          class="timeline-icon bg-primary p-3"
                          :class="{'bg-danger': el.stato == 'refuse','bg-warning': el.stato == 'update'}"
                        >
                          <vs-button class="no-pointer-event w-5 h-5" radius color="white" type="flat" icon-pack="feather" :icon="$rimb.icon_of(el.stato)" />
                        </div>
                        <div class="timeline-info">
                          <p class="font-semibold">{{$rimb.label_of(el.stato)}}</p>
                          <hr style="border-top: 1px dashed #d5d5d5;" class="my-3" />
                          <span class="activity-desc">
                            {{
                              $tariffe.formatDateNew(new Date(el.data))
                            }}
                          </span>
                          <span class="text-grey mx-2 activity-desc">
                            {{
                              'da utente: '
                            }}
                          </span>
                          <span class="activity-desc">
                            {{
                              [
                                el.utente.cognome,
                                el.utente.nome
                              ].join(' ')
                            }}
                          </span>
                        </div>
                        <p v-if="el.stato == 'request' && el.causale" class="text-warning">
                          {{
                            [
                            'Causale richiesta: ',
                            el.causale
                            ].join(' ')
                          }}
                        </p>
                        <p v-if="el.stato == 'paid' && selected.importo_pagato" class="text-warning">
                          {{
                            [
                            'Importo registrato: ',
                            `(${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo_pagato)})`,
                            new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected.importo),
                            ' €'
                            ].join(' ')
                          }}
                        </p>
                        <!-- <hr style="border-top: 1px dashed grey;" class="my-3" /> -->
                      </li>
                    </ul>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </tab-content>
        </form-wizard>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import FormWizard from '@/components/vue-form-wizard/FormWizard.vue'
import TabContent from '@/components/vue-form-wizard/TabContent.vue'
// import ItemListView from '@/components/ItemListView.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import ShowPreventivo from './ShowPreventivo.vue'
import StepDocumentazione from './StepDocumentazione.vue'

// datepicker + languages
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';

export default {
  data() {
    return {
      datepicker_format: "d.MM.yyyy",
      languages: lang,

      n_rimborso: '',

      return_logo_string: 'CEDASCOM',
    }
  },
  props: {
    selected: Object,
  },
  methods: {
    stop(ev) {
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      if (ev) ev.stopPropagation()
    },
    appendDesc() {
      let element = document.getElementById('quill-note')
      element.innerHTML = this.selected.note;
    },
  },
  created() {
    if (this.selected) {
      setTimeout(() => this.appendDesc(),50)

      let d_n = new Date(this.selected.data_inserimento).getYear() + 1900
      this.n_rimborso = [this.selected.numero,'/',d_n].join('')
    }
  },
  components: {
    FormWizard,
    TabContent,

    StepDocumentazione,
  },
}
</script>
